const countryCode = localStorage.getItem('actualCountryCode');
export default () => ({
  actionBar: {
    country: countryCode ? countryCode : 'QC',
    tax: 'IN',
  },
});
